import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SecurityFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M37.57 7.085c-.902.2-1.703.2-2.505.2-4.61 0-8.819-2.305-11.324-6.113-.702-1.003-2.405-1.003-3.006 0C18.129 4.98 13.82 7.286 9.21 7.286c-1.203.2-2.906-.702-4.009.2-.4.3-.701.802-.701 1.403v18.542c0 5.112 3.207 9.722 8.117 11.426 2.906 1.003 5.712 2.706 8.218 5.112a1.829 1.829 0 0 0 2.405 0c2.605-2.305 5.311-4.01 8.217-5.112 4.81-1.704 8.017-6.314 8.017-11.426V8.89c.2-1.203-.801-2.004-1.904-1.804Zm-6.814 9.923c0 .2-.1.5-.3.601L19.731 28.333c-.4.401-.902.301-1.302 0l-4.71-4.71c-.802-.802.4-2.105 1.302-1.303l4.009 4.109 10.021-10.023c.601-.5 1.704-.1 1.704.602Z"
  }));
});
SecurityFill.displayName = 'SecurityFill';
SecurityFill.defaultProps = {
  'aria-label': 'SecurityFill'
};
export default SecurityFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SecurityFill.js
// module id = 3903
// module chunks = 11